import React from "react";
import "./WhatsappConversationModal.scss";
import { Modal } from "antd";
import { UserOutlined } from "@ant-design/icons";
import {ReactComponent as CollectEaze} from "../../../assets/Icons/CollectEaze.svg"
import {ReactComponent as Customer} from "../../../assets/Icons/Customer.svg"

const WhatsappConversationModal = ({ open, onClose }) => {
  const conversation = [
    {
      sender: "CollectEaze",
      time: "01:00pm.",
      message: "Hi Customer, your loan payment of ₹18,500 is overdue. Please clear it by April 30 to avoid penalties.",
      icon: <CollectEaze/>,
    },
    {
      sender: "Customer",
      time: "01:32pm.",
      message: "I already spoke to someone!",
      icon: <Customer/>,
    },
    {
      sender: "CollectEaze",
      time: "01:32pm.",
      message: "Would you like to speak with a recovery expert? Reply 1 for Yes, 2 for No.",
      icon: <CollectEaze/>,
    },
    {
      sender: "Customer",
      time: "01:33pm.",
      message: "1",
      icon: <Customer/>,
    },
    {
      sender: "CollectEaze",
      time: "01:34pm.",
      message: "Thank you. We'll arrange a callback shortly.",
      icon: <CollectEaze/>,
    },
    {
        sender: "Customer",
        time: "01:33pm.",
        message: "1",
        icon: <Customer/>,
      },
      {
        sender: "CollectEaze",
        time: "01:34pm.",
        message: "Thank you. We'll arrange a callback shortly.",
        icon: <CollectEaze/>,
      },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={<div className="modal-header">WhatsApp Chat Transcript <span>Apr 23, 2025</span></div>}
      width={581}
    //   height={550}
      className="WhatsappModal"
    >
      <div className="conversation-timeline">
        {conversation.map((item, index) => (
          <div className="timeline-item" key={index}>
            <div className="timeline-icon">
              {typeof item.icon === "string" ? (
                <div className="circle-icon">{item.icon}</div>
              ) : (
                item.icon
              )}
            </div>
            <div className="timeline-content">
              <div className="sender-time">
                <span className="sender">{item.sender}</span>
                <span className="time">{item.time}</span>
              </div>
              <div className="message">{item.message}</div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default WhatsappConversationModal;
